(function () {
    'use strict';

    angular
        .module('app.accountSettings')
        .config(configRoutes);

    configRoutes.$inject = ['$stateProvider', 'accountSettingsResolver', 'homeCourseResolver'];
    function configRoutes($stateProvider, accountSettingsResolver, homeCourseResolver) {

        $stateProvider.state('account-settings.default', {
            url: '',
            component: 'sc3AccountSettings',
            resolve: accountSettingsResolver
        });

        $stateProvider.state('account-settings.home-course', {
            url: '/home-course',
            component: 'sc3HomeCourse',
            resolve: homeCourseResolver
        });
    }
})();